export const featureFlags = {
  AVA_INTEGRATION_23: true,
  BLACKLIST_POST_ECOMM_6: false,
  REPLACE_FIREBASE_AUTH_7: true,
  PRODUCT_REPORT_CAT_14: true,
  PRODUCT_RANKING_20: true,
};
